import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'components_library/atoms/Link/Link';
import Image from 'components_library/atoms/Image/Image';
import analyticsWrapper from 'components_library/utils/analyticsWrapper';
import s from './Header.scss';

const Header = props => {
  const { heading = {}, ga, typeShemaClassNames, isMobile } = props;
  const { text: headingname, link, size, icon } = heading;

  const listingClassName = classNames(typeShemaClassNames, {
    [s.header]: true,
    [s[size]]: size,
  });

  if (!headingname) return null;

  const onClick = () => {
    if (ga && ga.type) {
      analyticsWrapper('ga4', {
        event: 'user_click',
        type: ga.type,
        category: 'section_heading_click',
        label: headingname,
      });
    }
  };

  return (
    <div className={`${listingClassName}`}>
      {link ? (
        <>
          <h2 className={`${s.heading}`}>
            {icon && (
              <span className={s.hLeftIcon}>
                <Image
                  lazyload
                  offsetVertical={400}
                  height={isMobile ? '24' : '40'}
                  width={isMobile ? '24' : '40'}
                  msid={icon}
                />
              </span>
            )}
            <Link className={`${s.linkarrow}`} {...link} onClick={onClick}>
              <span className={s.head_ellipsis}>{headingname}</span>
            </Link>
          </h2>
        </>
      ) : (
        <>
          <h2 className={s.heading}>
            {icon && (
              <span className={s.hLeftIcon}>
                <Image
                  lazyload
                  offsetVertical={400}
                  height={isMobile ? '24' : '40'}
                  width={isMobile ? '24' : '40'}
                  msid={icon}
                />
              </span>
            )}
            {headingname}
          </h2>
        </>
      )}

      {React.isValidElement(props.children) && props.children}
    </div>
  );
};

Header.propTypes = {
  children: PropTypes.element,
  heading: PropTypes.shape({}),
  ga: PropTypes.shape({}),
  isMobile: PropTypes.bool,
};

Header.defaultProps = {
  children: undefined,
  heading: {},
  ga: undefined,
  isMobile: false,
};

export default Header;
